import dayjs from 'dayjs';

export default {
  getForm: state => state.form,
  getFormatEventDateTime: state => {
    const { eventDate, eventDateTime } = state.form;

    let val = eventDateTime?.split(':') ?? [];

    if (!val) {
      return dayjs(eventDate).format('YYYY년 MM월 DD일');
    } else {
      return dayjs(eventDate).format('YYYY년 MM월 DD일') + ' ' + val[0] + '시 ' + val[1] + '분';
    }
  },
  getMessage: state => state.form.message,

  getAlert: state => state.form.alertList,
  getDetail: state => state.detail,
  getNextId: state => state.nextId,
  getPagingCondition: state => state.pagingCondition,
  getCommentList: state => state.commentList,
  getPlaceList: state => state.placeList,
  getList: state => state.list,
  getBackground: state => state.background,
  getBackgroundPreViewImage: state => state.backgroundPreViewImage
};
